export enum ChartType {
  bar = 1,
  line = 2,
  pie = 3,
}
